// for encoding forms
$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        var val;
        if (this.value == $(this).prop('placeholder'))
            val = '';
        else
            val = this.value || '';

        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(val);
        } else {
            o[this.name] = val;
        }
    });
    return o;
};
